import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromWarehouse from '../_reducers/warehouse';

export const selectWarehouseState =
  createFeatureSelector<fromWarehouse.WarehouseState>('warehouses');

export const selectAllWarehouses = createSelector(selectWarehouseState, fromWarehouse.selectAll);

export const selectWarehouseEntities = createSelector(
  selectWarehouseState,
  fromWarehouse.selectEntities
);

export const selectWarehouseById = (id: number) =>
  createSelector(selectWarehouseEntities, (entities) => entities[id]);

export const selectWarehouseTotal = createSelector(selectWarehouseState, fromWarehouse.selectTotal);

export const selectWarehousesLoaded = createSelector(selectWarehouseState, (state) => state.loaded);
